import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'workspace-page';
export const useWorkspaceTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);

export const ruRu = (__LOCALE_RU__ ? ({
  [ns]: {
    geolocation_filter: {
      title: 'Локация',
      map: 'Карта',
      address: 'Адрес',
      coordinates: 'Координаты',
      city: 'Город',
      region: 'Область',
      district: 'Район',
      street: 'Улица',
      house_number: 'Номер дома',
      longitude: 'Долгота (-180...180)',
      latitude: 'Широта (-90...90)',
      accuracy: 'Погрешность (0...90)',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [ns]: {
    geolocation_filter: {
      title: 'Geolocation',
      map: 'Map',
      address: 'Address',
      coordinates: 'Coordinates',
      city: 'City',
      region: 'Region',
      district: 'District',
      street: 'Street',
      house_number: 'House number',
      longitude: 'Longitude (-180...180)',
      latitude: 'Latitude (-90...90)',
      accuracy: 'Accuracy (0...90)',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [ns]: {
    geolocation_filter: {
      title: 'Geolocalización',
      map: 'Mapa',
      address: 'Dirección',
      coordinates: 'Coordenadas',
      city: 'Ciudad',
      region: 'Región',
      district: 'Distrito',
      street: 'Calle',
      house_number: 'Número de casa',
      longitude: 'Longitud (-180...180)',
      latitude: 'Latitud (-90...90)',
      accuracy: 'Precisión (0...90)',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [ns]: {
    geolocation_filter: {
      title: 'Geolocalização',
      map: 'Mapa',
      address: 'Endereço',
      coordinates: 'Coordenadas',
      city: 'Cidade',
      region: 'Região',
      district: 'Distrito',
      street: 'Rua',
      house_number: 'Número da casa',
      longitude: 'Longitude (-180...180)',
      latitude: 'Latitude (-90...90)',
      accuracy: 'Precisão (0...90)',
    },
  },
}) : {}) as Record<string, unknown>;
